import { render, staticRenderFns } from "./informacion_cargosprolipa.vue?vue&type=template&id=5660d0dd&scoped=true"
import script from "./informacion_cargosprolipa.vue?vue&type=script&lang=js"
export * from "./informacion_cargosprolipa.vue?vue&type=script&lang=js"
import style0 from "./informacion_cargosprolipa.vue?vue&type=style&index=0&id=5660d0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5660d0dd",
  null
  
)

export default component.exports